import api from './api';

const getList = async (schoolSubjectId, schoolYearId) => {
    try {
        const response = await api.get(`/academic/schoolSubjectPercentagePeriodGrades`, { params: { schoolSubjectId, schoolYearId } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const create = async (data) => {
    try {
        const response = await api.post(`/academic/schoolSubjectPercentagePeriodGrades`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const update = async (data) => {
    try {
        const response = await api.put(`/academic/schoolSubjectPercentagePeriodGrades`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteById = async (id) => {
    try {
        const response = await api.delete(`/academic/schoolSubjectPercentagePeriodGrades/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default {
    getList,
    create,
    update,
    deleteById
};
